import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Manifesto } from "@/components/Manifesto";
import { Services } from "@/components/Services";
import { BeforeAfter } from "@/components/BeforeAfter";
import { Reviews } from "@/components/Reviews";
import { TipsTeaser } from "@/components/TipsTeaser";
import { QuoteTool } from "@/components/QuoteTool";
import { Swansea } from "@/components/Swansea";
import { Footer } from "@/components/Footer";
import { Seo, localBusinessSchema } from "@/seo/Seo";
import { BUSINESS } from "@/data/servicesData";
import { REVIEWS, AGG } from "@/data/testimonials";

export default function Home() {
  const scrollToQuote = () => document.querySelector("#quote")?.scrollIntoView({ behavior: "smooth" });

  const business = {
    ...localBusinessSchema(),
    aggregateRating: { "@type": "AggregateRating", ratingValue: AGG.rating, reviewCount: AGG.count, bestRating: 5 },
    review: REVIEWS.map((r) => ({
      "@type": "Review",
      author: { "@type": "Person", name: r.name },
      reviewRating: { "@type": "Rating", ratingValue: r.rating, bestRating: 5 },
      reviewBody: r.text,
    })),
  };

  return (
    <div className="bg-white" data-testid="home-page">
      <Seo
        title="Handyman & DIY Services in Swansea | FIT N FIX DIY Services"
        description={`Trusted local handyman & DIY services across Swansea & Gower — flat-pack assembly, TV mounting, painting, gutters, fencing & repairs. £${BUSINESS.minCharge} minimum per job, price quoted by email.`}
        path="/"
        keywords={["handyman swansea", "diy services swansea", "handyman near me", "flat pack assembly swansea", "gutter cleaning swansea"]}
        jsonLd={[business]}
      />
      <Navbar />
      <Hero onQuote={scrollToQuote} />
      <Marquee />
      <Manifesto />
      <Services onQuote={scrollToQuote} />
      <BeforeAfter />
      <QuoteTool />
      <Marquee reverse bg="#2563EB" fg="#0A1A4A" />
      <Reviews />
      <TipsTeaser />
      <Swansea />
      <Footer />
    </div>
  );
}
